package one.healthium.insights.ui.shopping_list.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Column
import androidx.compose.foundation.layout.PaddingValues
import androidx.compose.foundation.layout.Spacer
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import one.healthium.insights.ui.shopping_list.models.CategoriesUiModel
import one.healthium.insights.ui.shopping_list.models.CategoryUiModel
import one.healthium.insights.ui.shopping_list.models.HeaderUiModel
import one.healthium.loco.asLString
import one.healthium.loco.resolve
import one.healthium.ui.compose.theme.AppTheme
import androidx.compose.ui.tooling.preview.Preview

@Composable
internal fun ShoppingHeaderItem(
    modifier: Modifier = Modifier,
    uiModel: HeaderUiModel,
    onCategoryClicked: (CategoryUiModel) -> Unit,
    onUncheckAllClicked: (HeaderUiModel) -> Unit,
) {
    Column(
        modifier = modifier
            .background(AppTheme.colors.windowBackground)
            .fillMaxWidth()
            .padding(top = 12.dp, start = 4.dp, bottom = 12.dp, end = 4.dp)
    ) {
        Text(
            modifier = Modifier.padding(horizontal = 12.dp),
            text = uiModel.text.resolve(),
            style = AppTheme.textStyles.secondary_17_500,
            color = AppTheme.colors.text100,
        )
        if (uiModel.categories != null) {
            Spacer(Modifier.height(12.dp))
            CategoriesItem(
                uiModel = uiModel.categories,
                onCategoryClicked = onCategoryClicked,
                contentPadding = PaddingValues(horizontal = 12.dp),
            )
        }
    }
}

@Composable
@Preview(showBackground = true)
private fun HeaderItemPreview() {
    AppTheme {
        ShoppingHeaderItem(
            uiModel = HeaderUiModel(
                id = "test",
                text = "Test header".asLString(),
                categories = null,
            ),
            onCategoryClicked = {},
            onUncheckAllClicked = {},
        )
    }
}

@Composable
@Preview(showBackground = true)
private fun HeaderItemPreviewWithCategories() {
    AppTheme {
        ShoppingHeaderItem(
            uiModel = HeaderUiModel(
                id = "test",
                text = "Test header with categories".asLString(),
                categories = CategoriesUiModel(
                    categories = listOf(
                        CategoryUiModel(
                            "category_1",
                            name = "All".asLString(),
                        ),
                        CategoryUiModel(
                            "category_2",
                            name = "Category 2".asLString(),
                        ),
                        CategoryUiModel(
                            "category_3",
                            name = "Category 3".asLString(),
                        ),
                        CategoryUiModel(
                            "category_4",
                            name = "Category 4".asLString(),
                        )
                    ),
                    currentCategoryId = "category_1",
                ),
            ),
            onCategoryClicked = {},
            onUncheckAllClicked = {},
        )
    }
}